



















import Vue from "vue";
import { ElementColors } from "@/common/theme/ElementColors";

export default Vue.extend({
  name: "PPCancelOrder",
  props: {
    transactionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ElementColors,
    };
  },
});
